/**
 * Workshop city cart — live capacity enforce for drawer / cart page.
 */
(function (global) {
  'use strict';

  if (global.__WCF_CART_LIVE_BOOTED) return;
  global.__WCF_CART_LIVE_BOOTED = true;

  var DEFAULT_MAX_QTY = 20;
  var DEFAULT_CART_OPEN_POLL_MS = 10000;
  var refreshTimer = null;
  var drawerPollTimer = null;
  var drawerPollBound = false;
  var drawerStreamUnsub = null;
  var drawerStreamPaused = false;
  var drawerStreamPending = false;
  var xCartPatched = false;

  var liveCache = {
    as_of: null,
    states: {},
  };

  var lastLiveRefresh = {
    ok: true,
    attempted: false,
    missingGids: [],
    requestedGids: [],
  };

  var refreshInFlight = null;
  var bannerSyncInFlight = null;
  var cartConfigRoot = null;

  function configRoot() {
    if (!cartConfigRoot) {
      cartConfigRoot = {
        getAttribute: function (name) {
          if (name !== 'data-section-id') return '';
          var page = global.document && global.document.getElementById('WcfConfig-cart-page');
          return page ? 'cart-page' : 'cart-drawer';
        },
      };
    }
    return cartConfigRoot;
  }

  function readConfig() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.readBootstrap === 'function') {
      return CFG.readBootstrap(configRoot());
    }
    var ids = ['WcfConfig-cart-drawer', 'WcfConfig-cart-page'];
    for (var i = 0; i < ids.length; i++) {
      var script = global.document && global.document.getElementById(ids[i]);
      if (script && script.textContent) {
        try {
          return JSON.parse(script.textContent);
        } catch (_) {}
      }
    }
    return {};
  }

  function cssEscape(value) {
    if (global.CSS && typeof global.CSS.escape === 'function') return global.CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function enforceConfig() {
    return readConfig().enforce || {};
  }

  function gatesConfig() {
    return readConfig().gates || {};
  }

  function policyConfig() {
    return readConfig().policy || {};
  }

  function validateFailModeOpen() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.validateFailModeOpen === 'function') {
      return CFG.validateFailModeOpen(configRoot());
    }
    return String(policyConfig().validate_fail_mode || 'closed').toLowerCase() === 'open';
  }

  function skipVerifyUx() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.skipCapacityVerifyUx === 'function') {
      return CFG.skipCapacityVerifyUx();
    }
    return !!(CFG && CFG.TEMP_DISABLE_CAPACITY_VALIDATE === true);
  }

  function liveFetchFailModeOpen() {
    if (skipVerifyUx()) return true;
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.liveFetchFailModeOpen === 'function') {
      return CFG.liveFetchFailModeOpen(configRoot());
    }
    return String(policyConfig().live_fetch_fail_mode || 'closed').toLowerCase() === 'open';
  }

  function maxStaleMsBeforeCheckout() {
    var gates = gatesConfig();
    if (gates.max_stale_ms_before_checkout != null && gates.max_stale_ms_before_checkout !== '') {
      return Number(gates.max_stale_ms_before_checkout);
    }
    return 10000;
  }

  function cartOpenPollIntervalMs() {
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.cartOpenPollIntervalMs === 'function') {
      return CFG.cartOpenPollIntervalMs(configRoot());
    }
    return DEFAULT_CART_OPEN_POLL_MS;
  }

  function parseTimestampMs(value) {
    if (value == null || value === '') return NaN;
    var t = new Date(value).getTime();
    return Number.isFinite(t) ? t : NaN;
  }

  function maxStaleMsBeforeQtyChange() {
    var gates = gatesConfig();
    if (gates.max_stale_ms_before_qty_change != null && gates.max_stale_ms_before_qty_change !== '') {
      return Number(gates.max_stale_ms_before_qty_change);
    }
    if (gates.max_stale_ms_before_add != null && gates.max_stale_ms_before_add !== '') {
      return Number(gates.max_stale_ms_before_add);
    }
    return 15000;
  }

  function capacityAsOfMs(eventGid, slot) {
    var live = liveStateForGid(eventGid);
    var raw =
      (live && live.capacity_as_of != null && live.capacity_as_of !== '' && live.capacity_as_of) ||
      (slot && slot.capacity_as_of) ||
      liveCache.as_of;
    return parseTimestampMs(raw);
  }

  function isCapacityStale(eventGid, slot, maxStaleMs) {
    maxStaleMs = Number(maxStaleMs);
    if (!Number.isFinite(maxStaleMs) || maxStaleMs <= 0) return false;
    var asOfMs = capacityAsOfMs(eventGid, slot);
    if (!Number.isFinite(asOfMs)) return true;
    return Date.now() - asOfMs > maxStaleMs;
  }

  function hasLiveStateForGid(eventGid) {
    var live = liveStateForGid(eventGid);
    if (!live || typeof live !== 'object') return false;
    return (
      (live.capacity_remaining != null && live.capacity_remaining !== '') ||
      (live.status != null && live.status !== '') ||
      (live.display_status != null && live.display_status !== '') ||
      (live.capacity_as_of != null && live.capacity_as_of !== '')
    );
  }

  function missingLiveStateGids(gids) {
    var missing = [];
    (gids || []).forEach(function (gid) {
      if (!hasLiveStateForGid(gid)) missing.push(gid);
    });
    return missing;
  }

  function resolveLiveStateUrl() {
    var root = configRoot();
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.resolveLiveStateApiUrl === 'function') {
      return CFG.resolveLiveStateApiUrl(root);
    }
    var API = global.WorkshopCityEvents;
    if (API && typeof API.resolveLiveStateApiUrl === 'function') {
      return API.resolveLiveStateApiUrl(root);
    }
    return '';
  }

  function lineMetaFromEl(el) {
    if (!el) return null;
    var host = el.closest('[data-wcf-cart-line]');
    if (!host || host.getAttribute('data-wcf-cart-line') !== '1') return null;
    return {
      lineKey: host.getAttribute('data-cart-line-key') || '',
      eventGid: host.getAttribute('data-event-gid') || '',
    };
  }

  function isWorkshopLineKey(lineKey) {
    if (!lineKey) return false;
    var host = global.document && global.document.querySelector('[data-cart-line-key="' + cssEscape(lineKey) + '"]');
    return !!(host && host.getAttribute('data-wcf-cart-line') === '1');
  }

  function collectEventGidsFromDom() {
    var seen = {};
    var gids = [];
    if (!global.document) return gids;
    global.document.querySelectorAll('[data-wcf-cart-line="1"][data-event-gid]').forEach(function (el) {
      var gid = String(el.getAttribute('data-event-gid') || '').trim();
      if (!gid || seen[gid]) return;
      seen[gid] = true;
      gids.push(gid);
    });
    return gids;
  }

  function fetchCart() {
    var rootPath = (global.Shopify && global.Shopify.routes && global.Shopify.routes.root) || '/';
    return fetch(rootPath + 'cart.js', { credentials: 'same-origin' })
      .then(function (res) {
        return res.ok ? res.json() : null;
      })
      .catch(function () {
        return null;
      });
  }

  function lineQty(cart, lineKey) {
    if (!cart || !cart.items || !lineKey) return 0;
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].key === lineKey) return cart.items[i].quantity || 0;
    }
    return 0;
  }

  function eventGidFromCartItem(item) {
    var F = global.WorkshopCityFlow;
    if (F && typeof F.eventGidFromCartLine === 'function') {
      return F.eventGidFromCartLine(item);
    }
    if (!item || !item.properties) return '';
    return String(item.properties._event_metaobject_gid || item.properties._event_id || '').trim();
  }

  function liveStateForGid(eventGid) {
    var gid = String(eventGid || '').trim();
    if (!gid) return {};
    if (liveCache.states[gid]) return liveCache.states[gid];
    var API = global.WorkshopCityEvents;
    if (API && typeof API.eventIdAliases === 'function') {
      var aliases = API.eventIdAliases(gid);
      for (var i = 0; i < aliases.length; i++) {
        if (liveCache.states[aliases[i]]) return liveCache.states[aliases[i]];
      }
    }
    return {};
  }

  function canonicalEventId(eventGid) {
    var gid = String(eventGid || '').trim();
    if (!gid) return '';
    var live = liveStateForGid(gid);
    return String(live.canonical_event_id || gid).trim();
  }

  function isWorkshopAddonItem(item) {
    if (!item || !item.properties) return false;
    var props = item.properties;
    if (!Array.isArray(props)) return props._workshop_addon === 'true';
    for (var i = 0; i < props.length; i++) {
      var row = props[i];
      if (!row) continue;
      var k = row[0] != null ? row[0] : row.name;
      var v = row[1] != null ? row[1] : row.value;
      if (k === '_workshop_addon' && String(v) === 'true') return true;
    }
    return false;
  }

  function cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, desiredQty) {
    if (!cart || !cart.items) return desiredQty || 0;
    var API = global.WorkshopCityEvents;
    if (API && typeof API.seatsInCartForEvent === 'function' && typeof API.eventIdAliases === 'function') {
      var targetAliases = API.eventIdAliases(eventGid);
      if (!targetAliases.length) return desiredQty || 0;
      var total = 0;
      cart.items.forEach(function (item) {
        if (!item || isWorkshopAddonItem(item)) return;
        var itemGid = eventGidFromCartItem(item);
        if (!itemGid) return;
        var itemAliases = API.eventIdAliases(itemGid);
        var matches = targetAliases.some(function (alias) {
          return itemAliases.indexOf(alias) !== -1;
        });
        if (!matches) return;
        total += item.key === lineKey ? desiredQty || 0 : item.quantity || 0;
      });
      return total;
    }
    var targetCanonical = canonicalEventId(eventGid);
    if (!targetCanonical) return desiredQty || 0;
    var poolTotal = 0;
    (cart.items || []).forEach(function (item) {
      if (!item || isWorkshopAddonItem(item)) return;
      var gid = eventGidFromCartItem(item);
      if (!gid || canonicalEventId(gid) !== targetCanonical) return;
      poolTotal += item.key === lineKey ? desiredQty || 0 : item.quantity || 0;
    });
    return poolTotal;
  }

  function buildSlotFromLive(eventGid) {
    var gid = String(eventGid || '');
    var live = liveStateForGid(gid);
    var slot = {
      gid: gid,
      status: live.status || 'active',
      capacity_remaining: live.capacity_remaining,
      display_status: live.display_status,
      capacity_as_of: live.capacity_as_of || liveCache.as_of,
      canonical_event_id: live.canonical_event_id,
      capacity_group_id: live.capacity_group_id,
    };
    if (!hasLiveStateForGid(gid)) return slot;
    slot._live_state = live;
    slot._live_state_fresh = true;
    var API = global.WorkshopCityEvents;
    if (API && typeof API.mergeSlotWithLive === 'function') {
      return API.mergeSlotWithLive(slot, liveCache.states, liveCache.as_of) || slot;
    }
    return slot;
  }

  var UNVERIFIED_WORKSHOP_MSG =
    "Unfortunately we can't verify availability for this workshop item. Please remove it or contact us.";

  function clearLiveStateForGids(gids) {
    if (!gids || !gids.length) return;
    var API = global.WorkshopCityEvents;
    gids.forEach(function (gid) {
      if (API && typeof API.eventIdAliases === 'function') {
        API.eventIdAliases(gid).forEach(function (alias) {
          delete liveCache.states[alias];
        });
      }
      delete liveCache.states[gid];
    });
  }

  function refreshLiveResult(fetchOk, fetchAttempted, requestedGids) {
    return {
      cache: liveCache,
      fetchOk: fetchOk,
      fetchAttempted: fetchAttempted,
      missingGids: lastLiveRefresh.missingGids,
      requestedGids: requestedGids || lastLiveRefresh.requestedGids || [],
    };
  }

  function rememberLiveRefreshResult(fetchOk, fetchAttempted, requestedGids) {
    lastLiveRefresh.ok = fetchOk;
    lastLiveRefresh.attempted = fetchAttempted;
    lastLiveRefresh.requestedGids = (requestedGids || []).slice();
    if (fetchAttempted) {
      if (fetchOk) {
        lastLiveRefresh.missingGids = missingLiveStateGids(requestedGids);
      } else {
        lastLiveRefresh.missingGids = (requestedGids || []).slice();
      }
    } else {
      lastLiveRefresh.missingGids = [];
    }
    return refreshLiveResult(fetchOk, fetchAttempted, requestedGids);
  }

  function refreshLiveForGids(gids, force) {
    var requestedGids = (gids || []).slice();
    var gates = gatesConfig();
    if (!force && gates.live_fetch_on_cart_open === false && gates.live_fetch_on_qty_change === false) {
      return Promise.resolve(rememberLiveRefreshResult(true, false, requestedGids));
    }
    if (!requestedGids.length) {
      return Promise.resolve(rememberLiveRefreshResult(true, false, requestedGids));
    }
    var API = global.WorkshopCityEvents;
    if (!API || typeof API.fetchLiveState !== 'function') {
      clearLiveStateForGids(requestedGids);
      return Promise.resolve(rememberLiveRefreshResult(false, true, requestedGids));
    }
    return API.fetchLiveState(requestedGids, { url: resolveLiveStateUrl(), root: configRoot() })
      .then(function (r) {
        var states = (r && r.states) || {};
        var hasStates = Object.keys(states).length > 0;
        // Require both ok and states — empty "ok" responses must not mark lastLiveRefresh.ok
        // or ensureFreshBeforeCheckout / gateLineUpdate will skip a needed warm path.
        var fetchOk = !!(r && r.ok !== false && hasStates);
        if (hasStates) {
          clearLiveStateForGids(requestedGids);
          liveCache.states = Object.assign({}, liveCache.states, states);
          if (r.as_of) liveCache.as_of = r.as_of;
        } else if (!fetchOk) {
          clearLiveStateForGids(requestedGids);
        }
        return rememberLiveRefreshResult(fetchOk, true, requestedGids);
      })
      .catch(function () {
        clearLiveStateForGids(requestedGids);
        return rememberLiveRefreshResult(false, true, requestedGids);
      });
  }

  function maxQtyForLine(cart, lineKey, eventGid, slot) {
    var enforce = enforceConfig();
    var maxPerOrder =
      enforce.max_qty_per_order != null ? Number(enforce.max_qty_per_order) : DEFAULT_MAX_QTY;
    if (!Number.isFinite(maxPerOrder) || maxPerOrder <= 0) maxPerOrder = DEFAULT_MAX_QTY;

    var capMax = maxPerOrder;
    if (slot && slot.capacity_remaining != null && slot.capacity_remaining !== '') {
      var cap = Number(slot.capacity_remaining);
      if (Number.isFinite(cap) && cap >= 0) capMax = Math.min(maxPerOrder, cap);
    }

    var totalInCart = 0;
    var API = global.WorkshopCityEvents;
    if (API && typeof API.seatsInCartForEvent === 'function') {
      totalInCart = API.seatsInCartForEvent(eventGid, cart);
    } else {
      var F = global.WorkshopCityFlow;
      totalInCart = F && F.seatsInCartForEvent ? F.seatsInCartForEvent(cart, eventGid) : 0;
    }
    var thisQty = lineQty(cart, lineKey);
    var others = totalInCart - thisQty;
    var room = capMax - others;
    if (room < 0) room = 0;
    return Math.min(maxPerOrder, room);
  }

  function hasLiveCapacity(slot) {
    return !!(slot && slot.capacity_remaining != null && slot.capacity_remaining !== '');
  }

  function validateLineUpdate(cart, lineKey, eventGid, desiredQty) {
    if (gatesConfig().validate_before_cart_update !== true) {
      return Promise.resolve(null);
    }
    var API = global.WorkshopCityEvents;
    if (!API || typeof API.fetchCapacityValidate !== 'function') {
      if (validateFailModeOpen()) return Promise.resolve(null);
      return Promise.resolve({
        blocked: true,
        qty: lineQty(cart, lineKey),
        allowedQty: lineQty(cart, lineKey),
        message: 'We could not verify workshop capacity right now. Please try again.',
      });
    }
    return API.fetchCapacityValidate(configRoot(), {
      event_id: eventGid,
      requested_total_qty: cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, desiredQty),
      current_qty: lineQty(cart, lineKey),
      line_key: lineKey,
      intent: 'update_line',
    }).then(function (result) {
      if (result === null) return null;
      if (result && result.allowed === false) {
        var current = lineQty(cart, lineKey);
        var remaining = Number(result.capacity_remaining);
        var allowedQty = Number.isFinite(remaining)
          ? Math.max(0, remaining - (cartSeatsForPoolAfterUpdate(cart, eventGid, lineKey, 0) || 0))
          : current;
        return {
          blocked: true,
          qty: Math.min(current, allowedQty),
          allowedQty: allowedQty,
          message:
            result.message ||
            (allowedQty <= 0
              ? 'This session is sold out.'
              : 'Only ' + allowedQty + ' seat(s) remain for this session.'),
        };
      }
      return null;
    }).catch(function () {
      if (validateFailModeOpen()) return null;
      return {
        blocked: true,
        qty: lineQty(cart, lineKey),
        allowedQty: lineQty(cart, lineKey),
        message: 'We could not verify workshop capacity right now. Please try again.',
      };
    });
  }

  var STALE_CAPACITY_MSG =
    'Workshop availability data is out of date. Please try again in a moment.';
  var MISSING_LIVE_STATE_MSG =
    'We could not verify workshop availability right now. Please try again.';

  function currentLineQtyFromDom(lineKey, cart) {
    var fromCart = lineQty(cart, lineKey);
    if (fromCart > 0 || !lineKey) return fromCart;
    var inp = global.document && global.document.getElementById('cart-qty-' + lineKey);
    return parseInt((inp && inp.value) || '0', 10) || 0;
  }

  function eventGidsEquivalent(a, b) {
    var API = global.WorkshopCityEvents;
    if (API && typeof API.eventIdAliases === 'function') {
      var aList = API.eventIdAliases(a);
      var bList = API.eventIdAliases(b);
      for (var i = 0; i < aList.length; i++) {
        if (bList.indexOf(aList[i]) !== -1) return true;
      }
      return false;
    }
    return String(a || '').trim() === String(b || '').trim();
  }

  function liveRefreshCoversGids(currentGids) {
    var requested = lastLiveRefresh.requestedGids || [];
    currentGids = currentGids || [];
    if (!lastLiveRefresh.attempted) return false;
    if (!requested.length && !currentGids.length) return true;
    if (!requested.length) return false;
    if (!currentGids.length) return true;
    for (var i = 0; i < currentGids.length; i++) {
      var covered = false;
      for (var j = 0; j < requested.length; j++) {
        if (eventGidsEquivalent(currentGids[i], requested[j])) {
          covered = true;
          break;
        }
      }
      if (!covered) return false;
    }
    return true;
  }

  function liveRefreshStaleForGids(currentGids) {
    if (!currentGids || !currentGids.length) return false;
    if (!lastLiveRefresh.attempted) return true;
    return !liveRefreshCoversGids(currentGids);
  }

  function resolveValidateFallbackIntent() {
    var gates = gatesConfig();
    var CFG = global.WorkshopBookingConfig || global.WorkshopCityConfig;
    if (CFG && typeof CFG.validateGateEnabled === 'function') {
      if (CFG.validateGateEnabled(configRoot(), 'update_line')) return 'update_line';
      if (CFG.validateGateEnabled(configRoot(), 'checkout')) return 'checkout';
    }
    if (gates.validate_before_cart_update === true) return 'update_line';
    return null;
  }

  function tryValidateBannerOverride(liveCheck, guard) {
    var intent = resolveValidateFallbackIntent();
    if (
      !liveCheck ||
      liveCheck.bookable !== false ||
      liveCheck.message !== MISSING_LIVE_STATE_MSG ||
      !intent ||
      typeof guard.validateCart !== 'function'
    ) {
      return Promise.resolve(null);
    }
    return guard.validateCart(null, intent).then(function (verdict) {
      if (verdict && verdict.allowed === true && verdict.validation_unavailable !== true) {
        return { blocked: false, hide: true };
      }
      return null;
    });
  }

  function gateLineUpdate(lineKey, lineIndex, desiredQty) {
    desiredQty = parseInt(desiredQty, 10);
    if (!Number.isFinite(desiredQty) || desiredQty < 0) desiredQty = 0;

    if (!isWorkshopLineKey(lineKey)) {
      return Promise.resolve({ blocked: false, qty: desiredQty, allowedQty: desiredQty });
    }

    if (desiredQty === 0) {
      return Promise.resolve({ blocked: false, qty: 0, allowedQty: 0 });
    }

    var host = global.document.querySelector('[data-cart-line-key="' + cssEscape(lineKey) + '"]');
    var meta = lineMetaFromEl(host);
    if (!meta || !meta.eventGid) {
      if (skipVerifyUx()) {
        return Promise.resolve({ blocked: false, qty: desiredQty, allowedQty: desiredQty });
      }
      var blockedQty = currentLineQtyFromDom(lineKey, null);
      return Promise.resolve({
        blocked: true,
        qty: blockedQty,
        allowedQty: blockedQty,
        message: UNVERIFIED_WORKSHOP_MSG,
      });
    }

    var gates = gatesConfig();
    var fetchFresh = gates.live_fetch_on_qty_change !== false || gates.validate_before_cart_update === true;

    // Qty increase: fetch this line's event directly (not refreshFromDom — shared in-flight /
    // skipped fetch can leave liveCache empty while lastLiveRefresh.ok stays true).
    var refreshPromise = fetchFresh
      ? refreshLiveForGids([meta.eventGid], true)
      : refreshLiveForGids(collectEventGidsFromDom(), false);

    return refreshPromise.then(function (refreshResult) {
      return fetchCart().then(function (cart) {
        var slot = buildSlotFromLive(meta.eventGid);
        var currentQty = currentLineQtyFromDom(lineKey, cart);
        if (!cart) {
          if (skipVerifyUx()) {
            return { blocked: false, qty: desiredQty, allowedQty: desiredQty };
          }
          return {
            blocked: true,
            qty: currentQty,
            allowedQty: currentQty,
            message: 'We could not verify workshop availability right now. Please try again.',
          };
        }
        // Keeping or lowering the seat count can never overbook. Gating it would trap
        // a sold-out line at its current qty, leaving removal as the only way out.
        if (desiredQty <= lineQty(cart, lineKey)) {
          return { blocked: false, qty: desiredQty, allowedQty: desiredQty };
        }
        var qtyIncrease = desiredQty > currentQty;
        var liveFetchDone =
          refreshResult && refreshResult.fetchAttempted === true && refreshResult.fetchOk === true;
        if (fetchFresh && qtyIncrease && refreshResult && refreshResult.fetchAttempted && !refreshResult.fetchOk) {
          if (liveFetchFailModeOpen()) {
            liveFetchDone = false;
          } else {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: MISSING_LIVE_STATE_MSG,
            };
          }
        }
        if (fetchFresh && qtyIncrease && liveFetchDone && !skipVerifyUx()) {
          if (!hasLiveStateForGid(meta.eventGid)) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: MISSING_LIVE_STATE_MSG,
            };
          }
          if (isCapacityStale(meta.eventGid, slot, maxStaleMsBeforeQtyChange())) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: STALE_CAPACITY_MSG,
            };
          }
          if (!hasLiveCapacity(slot)) {
            return {
              blocked: true,
              qty: currentQty,
              allowedQty: currentQty,
              message: MISSING_LIVE_STATE_MSG,
            };
          }
        }
        var F = global.WorkshopCityFlow;
        if (F && F.slotBookable && !F.slotBookable(slot)) {
          return {
            blocked: true,
            qty: lineQty(cart, lineKey),
            allowedQty: 0,
            message: 'This session is no longer available.',
          };
        }
        var maxForLine = maxQtyForLine(cart, lineKey, meta.eventGid, slot);
        if (desiredQty > maxForLine) {
          var current = lineQty(cart, lineKey);
          return {
            blocked: true,
            qty: Math.min(current, maxForLine),
            allowedQty: maxForLine,
            message:
              maxForLine <= 0
                ? 'This session is sold out.'
                : 'Only ' + maxForLine + ' seat(s) remain for this session.',
          };
        }
        if (gates.validate_before_cart_update !== true) {
          return { blocked: false, qty: desiredQty, allowedQty: maxForLine };
        }
        return validateLineUpdate(cart, lineKey, meta.eventGid, desiredQty).then(function (validation) {
          return validation || { blocked: false, qty: desiredQty, allowedQty: maxForLine };
        });
      });
    }).catch(function () {
      if (skipVerifyUx()) {
        return { blocked: false, qty: desiredQty, allowedQty: desiredQty };
      }
      var fallbackQty = currentLineQtyFromDom(lineKey, null);
      return {
        blocked: true,
        qty: fallbackQty,
        allowedQty: fallbackQty,
        message: 'We could not verify workshop availability right now. Please try again.',
      };
    });
  }

  function showLineError(lineKey, message) {
    var err = global.document && global.document.getElementById('LineItemError-' + lineKey);
    if (err) {
      err.classList.remove('hidden');
      var text = err.getElementsByClassName('cart-item__error-text')[0];
      if (text) text.innerHTML = message;
      return;
    }
    if (message) global.alert(message);
  }

  function clearLineError(lineKey) {
    var err = global.document && global.document.getElementById('LineItemError-' + lineKey);
    if (err) err.classList.add('hidden');
  }

  function syncInput(lineKey, qty) {
    var inp = global.document && global.document.getElementById('cart-qty-' + lineKey);
    if (inp) inp.value = qty;
  }

  function liveRefreshResultFromLast() {
    return refreshLiveResult(
      lastLiveRefresh.ok,
      lastLiveRefresh.attempted,
      lastLiveRefresh.requestedGids
    );
  }

  function waitForDomEventGids(maxAttempts, delayMs) {
    maxAttempts = maxAttempts != null ? maxAttempts : 6;
    delayMs = delayMs != null ? delayMs : 100;

    function attempt(left) {
      var gids = collectEventGidsFromDom();
      if (gids.length || left <= 0) return Promise.resolve(gids);
      return new Promise(function (resolve) {
        global.setTimeout(function () {
          resolve(attempt(left - 1));
        }, delayMs);
      });
    }

    return attempt(maxAttempts);
  }

  function ensureLiveRefreshForDom() {
    return waitForDomEventGids().then(function (gids) {
      if (!gids.length) {
        rememberLiveRefreshResult(true, false, []);
        return liveCache;
      }
      if (refreshInFlight) return refreshInFlight;
      refreshInFlight = refreshLiveForGids(gids, true)
        .then(function (result) {
          return (result && result.cache) || liveCache;
        })
        .finally(function () {
          refreshInFlight = null;
        });
      return refreshInFlight;
    });
  }

  function refreshFromDom() {
    return ensureLiveRefreshForDom();
  }

  function isCheckoutLiveStale(gids) {
    var maxStale = maxStaleMsBeforeCheckout();
    if (!gids || !gids.length) return false;
    if (!Number.isFinite(maxStale) || maxStale <= 0) return false;
    if (liveRefreshStaleForGids(gids)) return true;
    var i;
    for (i = 0; i < gids.length; i++) {
      if (isCapacityStale(gids[i], buildSlotFromLive(gids[i]), maxStale)) return true;
    }
    return false;
  }

  function ensureFreshBeforeCheckout() {
    var gates = gatesConfig();
    if (gates.live_fetch_on_checkout === false) {
      return Promise.resolve(liveCache);
    }
    return waitForDomEventGids().then(function (gids) {
      if (!gids.length) return liveCache;
      var needsRefresh = isCheckoutLiveStale(gids);
      if (!needsRefresh && lastLiveRefresh.attempted && lastLiveRefresh.ok) {
        return liveCache;
      }
      return refreshLiveForGids(gids, true).then(function (result) {
        return (result && result.cache) || liveCache;
      });
    });
  }

  function checkDomBookabilityFromLive() {
    var gids = collectEventGidsFromDom();
    if (!gids.length) return { bookable: true };
    if (liveRefreshStaleForGids(gids)) {
      return { bookable: true, needsRefresh: true };
    }
    if (lastLiveRefresh.attempted && !lastLiveRefresh.ok) {
      if (skipVerifyUx()) return { bookable: true };
      return {
        bookable: false,
        message: MISSING_LIVE_STATE_MSG,
      };
    }
    if (lastLiveRefresh.attempted && lastLiveRefresh.ok && missingLiveStateGids(gids).length) {
      if (skipVerifyUx()) return { bookable: true };
      return {
        bookable: false,
        message: MISSING_LIVE_STATE_MSG,
      };
    }
    var F = global.WorkshopCityFlow;
    var Past = global.WorkshopCartPastEvents;
    for (var i = 0; i < gids.length; i++) {
      var slot = buildSlotFromLive(gids[i]);
      if (
        Past &&
        ((typeof Past.isPastSlot === 'function' && Past.isPastSlot(slot)) ||
          (typeof Past.isEndedStatus === 'function' &&
            Past.isEndedStatus(slot && slot.status, slot && slot.display_status)))
      ) {
        continue;
      }
      if (F && F.slotBookable && !F.slotBookable(slot)) {
        var cap = slot.capacity_remaining;
        return {
          bookable: false,
          message:
            cap != null && cap !== '' && Number(cap) <= 0
              ? 'This session is sold out.'
              : 'This session is no longer available.',
        };
      }
    }
    return { bookable: true };
  }

  function syncCartCapacityBanner(options) {
    options = options || {};
    if (bannerSyncInFlight) return bannerSyncInFlight;

    var guard = global.WorkshopCartCapacityGuard;
    if (!guard) return Promise.resolve({ blocked: false });

    function applyBanner(retryAfterStale) {
      var liveCheck = checkDomBookabilityFromLive();
      if (liveCheck && liveCheck.needsRefresh && !retryAfterStale) {
        return refreshFromDom().then(function () {
          return applyBanner(true);
        });
      }
      if (liveCheck && liveCheck.bookable === false) {
        return tryValidateBannerOverride(liveCheck, guard).then(function (override) {
          if (override && override.hide) {
            if (typeof guard.hideBlockBanner === 'function') guard.hideBlockBanner();
            return { blocked: false };
          }
          if (typeof guard.showBlockBanner === 'function') {
            guard.showBlockBanner(liveCheck.message || guard.defaultMessage);
          }
          return { blocked: true };
        });
      }
      var validateIntent = resolveValidateFallbackIntent();
      if (!validateIntent) {
        if (typeof guard.hideBlockBanner === 'function') guard.hideBlockBanner();
        return Promise.resolve({ blocked: false });
      }
      if (typeof guard.validateCart !== 'function') return Promise.resolve({ blocked: false });
      return guard.validateCart(null, validateIntent).then(function (verdict) {
        if (verdict && verdict.allowed === false) {
          if (typeof guard.showBlockBanner === 'function') {
            guard.showBlockBanner(verdict.message || guard.defaultMessage);
          }
          return { blocked: true };
        }
        if (typeof guard.hideBlockBanner === 'function') guard.hideBlockBanner();
        return { blocked: false };
      });
    }

    bannerSyncInFlight = (options.skipRefresh ? applyBanner() : refreshFromDom().then(applyBanner).catch(applyBanner)).finally(
      function () {
        bannerSyncInFlight = null;
      }
    );
    return bannerSyncInFlight;
  }

  function isCartSurfaceActive() {
    try {
      if (global.location && global.location.pathname === '/cart') return true;
      var mini = global.Alpine && global.Alpine.store && global.Alpine.store('xMiniCart');
      return !!(mini && mini.open);
    } catch (_) {
      return false;
    }
  }

  function stopDrawerCapacityPoll() {
    if (drawerPollTimer) {
      clearInterval(drawerPollTimer);
      drawerPollTimer = null;
    }
  }

  function tickDrawerCapacityPoll() {
    if (global.document && global.document.hidden) {
      drawerStreamPending = true;
      return;
    }
    drawerStreamPending = false;
    if (!isCartSurfaceActive()) {
      stopDrawerCapacityPoll();
      return;
    }
    syncCartCapacityBanner();
  }

  function onDrawerStream(evt) {
    var type = evt && evt.type;
    if (type === 'hello') {
      drawerStreamPaused = true;
      stopDrawerCapacityPoll();
      return;
    }
    if (type === 'live') {
      if (isCartSurfaceActive()) tickDrawerCapacityPoll();
      return;
    }
    drawerStreamPaused = false;
    if (isCartSurfaceActive()) startDrawerCapacityPoll();
  }

  function startDrawerCapacityPoll(pollOptions) {
    pollOptions = pollOptions || {};
    stopDrawerCapacityPoll();
    if (!isCartSurfaceActive()) return;
    var gates = gatesConfig();
    if (gates.live_fetch_on_cart_open === false) return;
    var ms = cartOpenPollIntervalMs();
    if (!(ms > 0) && !drawerStreamPaused) return;
    var initialDelay = pollOptions.initialDelayMs != null ? Number(pollOptions.initialDelayMs) : 0;
    if (initialDelay > 0) {
      global.setTimeout(tickDrawerCapacityPoll, initialDelay);
    } else {
      tickDrawerCapacityPoll();
    }
    if (drawerStreamPaused) return;
    if (!(ms > 0)) return;
    drawerPollTimer = global.setInterval(tickDrawerCapacityPoll, ms);
  }

  function restartDrawerPoll() {
    if (!isCartSurfaceActive()) {
      stopDrawerCapacityPoll();
      return;
    }
    startDrawerCapacityPoll();
  }

  function bindDrawerPollLifecycle() {
    if (drawerPollBound || !global.document) return;
    drawerPollBound = true;
    global.document.addEventListener('visibilitychange', function () {
      if (global.document.hidden) {
        stopDrawerCapacityPoll();
        return;
      }
      if (drawerStreamPending && isCartSurfaceActive()) tickDrawerCapacityPoll();
      if (isCartSurfaceActive() && !drawerStreamPaused) {
        startDrawerCapacityPoll();
        syncCartCapacityBanner();
      }
    });
    var Stream = global.WorkshopLiveStream;
    if (Stream && typeof Stream.subscribe === 'function') {
      if (typeof Stream.isSupported !== 'function' || Stream.isSupported()) {
        drawerStreamUnsub = Stream.subscribe(onDrawerStream);
      }
    }
  }

  function onCartDrawerOpen() {
    bindDrawerPollLifecycle();
    syncCartCapacityBanner();
    startDrawerCapacityPoll({ initialDelayMs: 200 });
  }

  function onCartDrawerClose() {
    stopDrawerCapacityPoll();
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      refreshFromDom();
    }, 120);
  }

  function wrapXCartFactory(factory) {
    return function () {
      var api = factory();
      var origPost = api._postUpdateItem.bind(api);

      api._postUpdateItem = function (itemId, line, qty, maxQty, wait, isShippingInsurance) {
        if (!isWorkshopLineKey(itemId)) {
          return origPost(itemId, line, qty, maxQty, wait, isShippingInsurance);
        }
        gateLineUpdate(itemId, line, qty).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            api.loading = false;
            var loadingEl = global.document.getElementById('loading-' + itemId);
            if (loadingEl) loadingEl.classList.add('hidden');
            var removeEl = global.document.getElementById('remove-' + itemId);
            if (removeEl) removeEl.style.display = 'block';
            return;
          }
          clearLineError(itemId);
          origPost(itemId, line, result.qty, result.qty, wait, isShippingInsurance);
        });
      };

      var origPlus = api.plusItemQty.bind(api);
      api.plusItemQty = function (itemId, line, inventory_policy, track_inventory, maxQty) {
        if (!isWorkshopLineKey(itemId)) {
          return origPlus.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var cur = parseInt((inp && inp.value) || '0', 10) || 0;
        gateLineUpdate(itemId, line, cur + 1).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            return;
          }
          clearLineError(itemId);
          if (inp) inp.value = result.qty;
          origPost(itemId, line, result.qty, result.qty);
        });
      };

      var origMinus = api.minusItemQty.bind(api);
      api.minusItemQty = function (
        itemId,
        line,
        inventory_policy,
        track_inventory,
        maxQty,
        willRemoveInsurance
      ) {
        if (!isWorkshopLineKey(itemId)) {
          return origMinus.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var cur = parseInt((inp && inp.value) || '0', 10) || 0;
        var next = cur > 0 ? cur - 1 : 0;
        if (inp) inp.value = next;
        clearLineError(itemId);
        origPost(itemId, line, next, next, 500, willRemoveInsurance);
      };

      var origUpdate = api.updateItemQty.bind(api);
      api.updateItemQty = function (
        itemId,
        line,
        inventory_policy,
        track_inventory,
        maxQty,
        willRemoveInsurance
      ) {
        if (!isWorkshopLineKey(itemId)) {
          return origUpdate.apply(api, arguments);
        }
        var inp = global.document.getElementById('cart-qty-' + itemId);
        var qty = parseInt((inp && inp.value) || '0', 10) || 0;
        if (!api.validateQty(qty)) return;
        gateLineUpdate(itemId, line, qty).then(function (result) {
          if (result.blocked) {
            showLineError(itemId, result.message);
            syncInput(itemId, result.qty);
            return;
          }
          clearLineError(itemId);
          if (inp) inp.value = result.qty;
          origPost(itemId, line, result.qty, result.qty, 500, willRemoveInsurance);
        });
      };

      return api;
    };
  }

  function patchXCart() {
    if (xCartPatched || !global.Alpine || typeof global.Alpine.data !== 'function') return false;
    var factory = global.Alpine.data('xCart');
    if (typeof factory !== 'function') return false;

    global.Alpine.data('xCart', wrapXCartFactory(factory));
    xCartPatched = true;
    return true;
  }

  var alpineDataHooked = false;

  function hookAlpineData() {
    if (alpineDataHooked || !global.Alpine || typeof global.Alpine.data !== 'function') return;
    alpineDataHooked = true;
    var origData = global.Alpine.data.bind(global.Alpine);
    global.Alpine.data = function (name, factory) {
      if (name === 'xCart' && typeof factory === 'function' && !xCartPatched) {
        xCartPatched = true;
        return origData(name, wrapXCartFactory(factory));
      }
      return origData.apply(global.Alpine, arguments);
    };
  }

  function schedulePatchXCart() {
    if (xCartPatched) return;
    hookAlpineData();
    var attempts = 0;
    function tryPatch() {
      if (xCartPatched) return;
      if (patchXCart()) return;
      if (attempts++ < 120) {
        global.setTimeout(tryPatch, 32);
      }
    }
    if (typeof queueMicrotask === 'function') {
      queueMicrotask(tryPatch);
    } else {
      global.setTimeout(tryPatch, 0);
    }
  }

  function boot() {
    schedulePatchXCart();
    scheduleRefresh();
    global.document.addEventListener('eurus:cart:items-changed', scheduleRefresh);
    if (global.location && global.location.pathname === '/cart') {
      bindDrawerPollLifecycle();
      syncCartCapacityBanner().then(function () {
        startDrawerCapacityPoll();
      });
    }
  }

  global.WorkshopCityCartLive = {
    refreshFromDom: refreshFromDom,
    ensureFreshBeforeCheckout: ensureFreshBeforeCheckout,
    gateLineUpdate: gateLineUpdate,
    isWorkshopLineKey: isWorkshopLineKey,
    showLineError: showLineError,
    maxQtyForLine: maxQtyForLine,
    buildSlotFromLive: buildSlotFromLive,
    checkDomBookabilityFromLive: checkDomBookabilityFromLive,
    syncCartCapacityBanner: syncCartCapacityBanner,
    onCartDrawerOpen: onCartDrawerOpen,
    onCartDrawerClose: onCartDrawerClose,
    restartDrawerPoll: restartDrawerPoll,
    hasLiveStateForGid: hasLiveStateForGid,
    isReady: function () {
      return xCartPatched;
    },
  };

  if (global.document.readyState === 'loading') {
    global.document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  global.document.addEventListener('alpine:init', schedulePatchXCart);
})(typeof window !== 'undefined' ? window : this);
